import LazyLoad from 'react-lazyload';
import StatePricingDisclaimer from './StatePricingDisclaimer';

interface IStatePricingDislaimerContainerProps {
    fullStoryPageId: string;
}

const StatePricingDisclaimerContainer = ({ fullStoryPageId }: IStatePricingDislaimerContainerProps) => (
    <LazyLoad offset={[400, 400]} height={1}>
        <StatePricingDisclaimer fullStoryPageId={fullStoryPageId} />
    </LazyLoad>
);

export default StatePricingDisclaimerContainer;
